import { useState } from "react"
import PropTypes from "prop-types"
import { api } from "utils/api"
import PanelTextEditor from "components/admin/PanelTextEditor"
import useUnsavedChangesAlert from "hooks/use_unsaved_changes_alert"

export default function SignUpDescription({ event: eventFromProps }) {
  const [status, setStatus] = useState(null)
  const [event, setEvent] = useState(eventFromProps)
  const [unsavedChanges, setUnsavedChanges] = useState(event.description)

  const handleSave = (description, handleClose) => {
    return api
      .put(event.paths.settingsNameDescription, { event: { description } })
      .then(response => {
        setEvent(response.event)
        setUnsavedChanges(response.event.description)
        handleClose()
      })
      .catch(response => {
        setStatus({
          text: response.errors || "Changes not saved",
          icon: "general#exclamation-triangle",
          type: "error"
        })

        setTimeout(() => setStatus(null), 3000)
      })
  }

  const { removeHandlers } = useUnsavedChangesAlert({
    savedData: event.description,
    currentData: unsavedChanges
  })

  const handleChange = e => {
    setUnsavedChanges(e)
  }

  const handleClose = () => {
    removeHandlers()
  }

  return (
    <PanelTextEditor
      name="signup_description"
      heading="Description"
      blankStateMessage="You can add a description to communicate details about this signup."
      blankStateButtonLabel="Edit description"
      contentHtml={event.description}
      saveStatus={status}
      onSave={handleSave}
      onChange={handleChange}
      onClose={handleClose}
    />
  )
}

SignUpDescription.propTypes = {
  event: PropTypes.shape({
    description: PropTypes.string,
    paths: PropTypes.shape({
      settingsNameDescription: PropTypes.string
    })
  })
}
